// Runs before anything else in the web bundle (prepended to the webpack entry
// in webpack.config.js).
//
// react-native removed `Component.propTypes` in 0.66 and react-native-web never
// had it, but react-native-material-textfield / -dropdown / react-native-check-box
// still read it at module scope:
//
//     style: Text.propTypes.style              // counter/index.js
//     ...TextInput.propTypes                   // field/index.js
//     ...TouchableWithoutFeedback.propTypes    // dropdown/index.js
//
// which throws "Cannot read properties of undefined (reading 'style')" while the
// bundle is still evaluating — before React renders anything, so the whole app
// shows a blank page.
//
// Aliasing the module (see src/web/react-native.js) fixes the *named* imports
// like ViewPropTypes, but these reads go through deep imports such as
// "react-native-web/dist/exports/Text" that bypass the alias entirely. Attaching
// the missing propTypes to the component objects themselves is what covers them.
// The validators are never enforced: nothing in the web build validates propTypes.

import PropTypes from "prop-types";
import {
	Image,
	ScrollView,
	Text,
	TextInput,
	TouchableHighlight,
	TouchableOpacity,
	TouchableWithoutFeedback,
	View,
} from "react-native-web/dist/index.js";

const legacyPropTypes = {
	style: PropTypes.any,
	accessible: PropTypes.bool,
	accessibilityLabel: PropTypes.node,
	children: PropTypes.node,
	onLayout: PropTypes.func,
	onPress: PropTypes.func,
	pointerEvents: PropTypes.string,
	testID: PropTypes.string,
};

for (const component of [
	View,
	Text,
	TextInput,
	Image,
	ScrollView,
	TouchableOpacity,
	TouchableHighlight,
	TouchableWithoutFeedback,
]) {
	if (component && !component.propTypes) {
		try {
			component.propTypes = legacyPropTypes;
		} catch (e) {
			// Frozen component: nothing else to try, and the consumer will throw
			// with a clearer message than anything logged here.
		}
	}
}
